module.exports = __webpack_public_path__ + "img/bgTitle7.eccf95a4.png";